
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import Member from '@/components/member/index';
import Service from "@/components/service/index";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Member,
    Service
  },
  data() {
    return {
      title: "Trang quản trị",
      items: [
        {
          text: "trang chủ",
          href: "/",
        },
        {
          text: "Trang quản trị",
          active: true,
        },
      ]
    };
  }
};
</script>
<template>
  <Layout>
    <PageHeader  :items="items" />
    <div class="row">
      <div class="col-xl-12">

        <Member/>
        <Service/>
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>
